export default __webpack_public_path__ + "static/media/track.f4928b0e.png";